import { render, staticRenderFns } from "./SubmissionListById.vue?vue&type=template&id=3ff243f0"
import script from "./SubmissionListById.vue?vue&type=script&lang=js"
export * from "./SubmissionListById.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports